import React, { Component } from 'react'
import { connect } from 'react-redux'
import setActiveEnhancements from '../../actions/setActiveEnhancementActions'
import removeActiveEnhancement from '../../actions/removeActiveEnhancementActions'
import '../../styles/css/components/enhancements/bk-flow-enhancements.css'

// GA events handler
import triggerCustomGaEvent from '../../utilities/analytics/triggerCustomGaEvent'

class BkFlowRoomEnhancementButton extends Component {

	constructor(props) {
		super(props)
		this.state = {
			enhancementsExpanded: this.props.enhancementsExpanded
		}
	}

	render() {
		const {
			activeEnhancementData,
			configData,
			enhancementApiData,
			enhancementKey,
			handleAddEnhancement,
			handleRemoveEnhancement,
			isEnhancementSelected,
			ratePlanCode,
			roomGroup,
			roomType,
		} = this.props

		const hotelLabels = configData.hotel.labels[0]

		return (
			<div className="bk-flow-enhancements__card-btn">
				{ isEnhancementSelected ?
					<button
						onClick={() => handleRemoveEnhancement(activeEnhancementData, enhancementKey)}
						className="btn btn-primary"
					>
						{ hotelLabels.remove ? hotelLabels.remove : 'Remove'}
					</button>
				:
					<button
						onClick={() => handleAddEnhancement(enhancementKey, enhancementApiData, roomGroup, roomType, ratePlanCode)}
						className="btn btn-primary"
					>
						{ hotelLabels.addToRoom ? hotelLabels.addToRoom : 'Select' }
					</button>
				}
			</div>
		)
	}
}

function mapStateToProps(state) {
	return {
		configData: state.configData.configuration,
		activeEnhancementData: state.activeEnhancementData
	}
}

const mapDispatchToProps = dispatch => ({
	handleAddEnhancement(enhancementKey, enhancementApiData, roomGroup, roomType, ratePlanCode) {
		const enhancementEntry = {}

		enhancementEntry[enhancementKey] = {
			enhancementApiData: enhancementApiData,
			roomGroup: roomGroup,
			roomType: roomType,
			ratePlanCode: ratePlanCode
		}

		// Dispatch activeRoom GA events
		triggerCustomGaEvent('analytics-addService', enhancementEntry)

		return dispatch(setActiveEnhancements(enhancementEntry))
	},
	handleRemoveEnhancement(activeEnhancements, enhancementKey) {
		// Dispatch activeRoom GA events
		triggerCustomGaEvent('analytics-removeService', enhancementKey)

		return dispatch(removeActiveEnhancement(enhancementKey))
	}
})

export default connect(mapStateToProps, mapDispatchToProps)(BkFlowRoomEnhancementButton)


// WEBPACK FOOTER //
// ./src/components/enhancements/BkFlowRoomEnhancementButton.js